import instance from "@/utils/require.js"

// 烧录工单--分页查询
export function apiOutwardOrderSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/outward_order/search",
		method: "post",
		data
	})
}export function apiOutwardRetry(data = {}) {
	return instance({
		url: "/aim/api/v3/outward_order/retry",
		method: "post",
		data
	})
}
export function apiOutwardDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/outward_order/delete",
		method: "post",
		data
	})
}
export function apiOutwardHandover(data = {}) {
	return instance({
		url: "/aim/api/v3/outward_order/handover",
		method: "post",
		data
	})
}
export function apiOutwardStatusList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/outward_status",
		method: "post",
		data
	})
}
export function apiOutwardIqc(data = {}) {
	return instance({
		url: "/aim/api/v3/outward_order/iqc",
		method: "post",
		data
	})
}
export function apiOutwardSkipIqc(data = {}) {
	return instance({
		url: "/aim/api/v3/outward_order/skip_iqc",
		method: "post",
		data
	})
}
export function apiOutwardOrderAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/outward_order/addOutward",
		method: "post",
		data
	})
}